import { render, staticRenderFns } from "./GiroList.vue?vue&type=template&id=710532a0&scoped=true"
import script from "./GiroList.vue?vue&type=script&lang=js"
export * from "./GiroList.vue?vue&type=script&lang=js"
import style0 from "./GiroList.vue?vue&type=style&index=0&id=710532a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710532a0",
  null
  
)

export default component.exports